(function () {
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.categories__swiper', {
      slidesPerView: 1.75,
      spaceBetween: 12,
      grabCursor: true,
      pagination: {
        el: '.categories__pagination',
        clickable: true,
      },
      breakpoints: {
        480: {
          slidesPerView: 2.5,
        },
        640: {
          slidesPerView: 3.5,
        },
        769: {
          slidesPerView: 4,
        },
        990: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 6,
        },
      },
    });
  });
})();